module.exports = __webpack_public_path__ + "img/brazil-flag.1c50cfe9.png";